import { AppDispatch } from '../store'
import { updatePrimarySecurity, setResolvedPrimarySecurity } from './home.reducer'
import { resolvePrimarySecurity } from '../util/security'

/**
 * Async thunk that fetches securities and stores resolved PrimarySecurity in Redux.
 */
export const updatePrimarySecurityAsync =
    (payload: Parameters<typeof updatePrimarySecurity>[0]) => async (dispatch: AppDispatch) => {
        dispatch(updatePrimarySecurity(payload))
        if (!payload.key) return
        try {
            const resolved = await resolvePrimarySecurity(payload)
            const resolvedOk = resolved.expressionMode
                ? resolved.expressionSecurities.length > 0
                : !!resolved.primary
            if (resolvedOk) {
                dispatch(setResolvedPrimarySecurity(resolved))
            }
        } catch (e) {
            console.error('Failed to resolve primary security:', e)
        }
    }
